<template>
  <div class="page-checkout">
    <h1 class="title">Comprar</h1>
    <div class="columns is-multiline">
      <div class="column is-7">
        <div class="box">
          <h2 class="title is-purple is-size-4">Datos personales</h2>
          <p class="mb-3">
            <span class="has-text-grey is-size-7"
              >* Todos los datos son requeridos</span
            >
          </p>
          <div class="fields">
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="field">
                  <div class="control">
                    <input
                      v-model.trim="user.firstName"
                      type="text"
                      placeholder="Nombre"
                      class="input"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <input
                      v-model.trim="user.lastName"
                      type="text"
                      class="input"
                      placeholder="Apellido"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <input
                      v-model.trim="user.email"
                      type="email"
                      class="input"
                      placeholder="Email"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <div class="control">
                    <input
                      v-model.trim="user.phone"
                      type="tel"
                      class="input"
                      placeholder="telefono"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <input
                      v-model.trim="user.address"
                      type="text"
                      class="input"
                      placeholder="Direccion"
                    />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <input
                      v-model.trim="user.zipCode"
                      type="text"
                      class="input"
                      placeholder="Codigo postal"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <div class="field">
                  <div class="control">
                    <button
                      @click.once="verificDataUser()"
                      class="button btn is-fullwidth mb-3"
                      type="submit"
                      id="form-checkout__submit"
                    >
                      Validar mi datos
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="notification is-danger mt-4" v-if="errors.length">
            <button class="delete" @click.once="removeError()"></button>
            <p v-for="error of errors" :key="error">{{ error }}</p>
          </div>
        </div>
        <div class="box is-relative">
          <div
            class="overlay"
            :class="{ 'is-active': !userCheckout }"
          ></div>
          <h2 class="title is-purple is-size-4">Metodo de pago</h2>
          <div class="buttons pay">
            <button
              class="button btn mx-1"
              :class="{ 'btn-active': creditCard }"
              @click="creditCard = !creditCard"
            >
              <i class="fas fa-credit-card"></i>
              <span class="mx-2">Tarjeta de credito</span>
            </button>
            <button
              class="button btn mx-1"
              :class="{ 'btn-active': money }"
              @click="money = !money"
            >
              <i class="fas fa-hand-holding-usd"></i>
              <span class="mx-2">Efectivo</span>
            </button>
            <button
              class="button btn mx-1"
              :class="{ 'btn-active': paypal }"
              @click="paypal = !paypal"
            >
              <i class="fab fa-cc-paypal"></i>
              <span class="mx-2">Paypal</span>
            </button>
          </div>
          <template v-if="creditCard">
            <FormCreditCard
              v-on:mercadoPagoTokenHandler="mercadoPagoTokenHandler"
            />
          </template>
          <template v-if="money">
            <FormEfective/>
          </template>
          <template v-if="paypal">
            <div class="notification is-warning">
              <p>Muy pronto tendremos accesibilidad a Paypal.</p>
            </div>
          </template>
        </div>
        <div class="box">
          <div class="wraper-footer">
            <div class="is-space-bet has-text-grey">
              <p><i class="fas fa-shield-alt"></i> Compra protegida</p>
              <p>
                Pago cifrado y verificado por
                <strong class="is-purple">MercadoPago</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-5">
        <div class="box">
          <h2 class="title is-purple is-size-5">Resumen del pedido</h2>
          <CartList v-for="item in items" :key="item.product.id" :item="item" />
          <div class="end-pay">
            <div class="is-space-bet">
              <p>Total articulos a comprar</p>
              <p>{{ cartTotalLength }}</p>
            </div>
            <div class="is-space-bet">
              <p>Subtotal</p>
              <p>{{ getTotal }}</p>
            </div>
            <hr />
            <div class="buttons is-right">
              <button class="button is-danger mx-1" @click.once="clearCart">
                Vaciar carrito
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/reactivity";
import axios from "axios";
import CartList from "@/components/CartList.vue";
import FormCreditCard from "@/components/FormCreditCard";
import FormEfective from '@/components/FormEfective.vue'
import { toast } from 'bulma-toast';

export default {
  name: "Checkout",
  components: {
    CartList,
    FormCreditCard,
    FormEfective
  },
  data() {
    return {
      userCheckout: false,
      creditCard: true,
      paypal: false,
      money: false,
      btnCheckout: false,
      items: {},
      checkout: [],
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
        zipCode: "",
      },
      errors: [],
    };
  },
  watch: {
    creditCard() {
      if (this.creditCard === true) {
        this.paypal = false;
        this.money = false;
      }
    },
    paypal() {
      if (this.paypal === true) {
        this.creditCard = false;
        this.money = false;
      }
    },
    money() {
      if (this.money === true) {
        this.creditCard = false;
        this.paypal = false;
      }
    },
  },
  beforeMount() {
    // this.getCheckoutOrderUser()
  },
  mounted() {
    document.title = "Verificar comprar | Shoper.co";
    this.items = this.$store.state.cart;
    // if (this.creditCard) { this.submitFormCheckout(); }
  },
  methods: {
    removeError() {
      this.errors = [];
    },
    mercadoPagoTokenHandler(data) {
      this.tokenHandler(data)
    },
    async getCheckoutOrderUser() {
      try {
        const res = await axios.get("/api/v1/checkout-order-user/");
        this.checkout = res.data;
      } catch (e) {
        console.error(e);
      }
    },
    verificDataUser() {
      if (this.user.firstName === "") {
        this.errors.push("El campo Nombre es requerido!");
      }
      if (this.user.lastName === "") {
        this.errors.push("El campo Apellido es requerido!");
      }
      if (this.user.email === "") {
        this.errors.push("El campo Email es requerido!");
      }
      if (this.user.phone === "") {
        this.errors.push("El campo Telefono es requerido!");
      }
      if (this.user.address === "") {
        this.errors.push("El campo Direccion es requerido!");
      }
      if (this.user.zipcode === "") {
        this.errors.push("The zip code field is missing!");
      }
      if (!this.errors.length) {
        this.userCheckout = !this.userCheckout
      }
    },
    async tokenHandler(data) {
      const items = [];
      const cart = Object.values(this.$store.state.cart);
      for (let i = 0; i < cart.length; i++) {
        const item = cart[i];
        const obj = {
          product: item.product.id,
          quantity: item.quantity,
          price: item.product.price * item.quantity,
        };
        items.push(obj);
      }
      const order = {
        first_name: this.user.firstName,
        last_name: this.user.lastName,
        email: this.user.email,
        phone: this.user.phone,
        address: this.user.address,
        zipcode: this.user.zipCode,
        items: items,
        mercadoPagoToken: data.token,
      };
      axios
        .put("/api/v1/create-order/", { order: order, data: data })
        .then((res) => {
          this.$store.commit('clearCart')
          console.log(res.data)
          if(res.data.status === 'approved') {
            toast({
              message: 'Tu solicitud de compra a sido aprobado',
              extraClasses: 'is-my-color',
              position: 'bottom-right',
              dismissible: true,
              pauseOnHover: true,
              duration: 2000
            })
          }
        });
    },
  },
  computed: {
    cartTotalLength() {
      return computed(() => this.$store.getters.getCartTotalLength);
    },
    getTotal() {
      let amount = Object.values(this.items).reduce(
        (acc, item) => acc + item.quantity * item.product.price,
        0
      );
      return accounting.formatMoney(amount, "$", 0, ".", ",");
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  z-index: 9999;
  border-radius: 5px;
  background-color: rgba(51, 51, 51, 0.342);
  transition: all linear .2s;
  &.is-active{
    inset: 0 0 0 0;
  }
}
.is-purple {
  color: #745192;
}
.end-pay {
  padding: 0 1rem;
}

.is-space-bet {
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;
}
.wraper-footer {
  padding: 1rem;
  border: #745192 1px solid;
  border-radius: 3px;
  .fas {
    color: #22e25c9f;
  }
}
.btn {
  color: #745192;
  background-color: #fff;
  border: #745192 solid 1px;
  transition: all linear 0.1s;
  margin-bottom: 2rem;
  &.btn-active {
    background-color: #745192;
    color: #fff;
  }
  &:hover {
    background-color: #745192;
    color: #fff;
  }
}
</style>